export default __webpack_public_path__ + "static/media/vscode-icons_file-type-swift.30e8054b.svg";